import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db, auth } from '../firebase/firebase';

// Calculate winicoins based on investment amount
export const calculateWinicoins = (amount) => {
  const amountNum = parseInt(amount);
  switch (amountNum) {
    case 72: return 6;
    case 144: return 12;
    case 360: return 30;
    case 720: return 60;
    case 1440: return 120;
    case 3600: return 300;
    case 7200: return 600;
    case 14400: return 1200;
    case 36000: return 3000;
    case 72000: return 6000;
    case 144000: return 12000;
    case 360000: return 30000;
    default: return 0;
  }
};

// Update user's winicoins in Firebase
export const updateUserWinicoins = async (amount) => {
  try {
    const user = auth.currentUser;
    
    if (!user) {
      throw new Error('User not authenticated');
    }

    const winicoinsToAdd = calculateWinicoins(amount);
    
    if (winicoinsToAdd === 0) {
      throw new Error('Invalid investment amount');
    }

    // Reference to user's wallet document
    const walletRef = doc(db, 'users', user.uid, 'wallet', 'winicoins');
    
    // Get current winicoins
    const walletDoc = await getDoc(walletRef);
    let currentWinicoins = 0;
    
    if (walletDoc.exists()) {
      currentWinicoins = walletDoc.data().winicoins || 0;
    }

    // Calculate new total
    const newTotal = currentWinicoins + winicoinsToAdd;

    // Update or create the document
    await setDoc(walletRef, {
      winicoins: newTotal,
      lastUpdated: new Date(),
      lastPurchase: {
        amount: amount,
        winicoinsAdded: winicoinsToAdd,
        timestamp: new Date()
      }
    }, { merge: true });

    return { success: true, winicoinsAdded: winicoinsToAdd, newTotal };
    
  } catch (error) {
    console.error('Error updating winicoins:', error);
    throw error;
  }
};

// Get user's current winicoins balance
export const getUserWinicoins = async () => {
  try {
    const user = auth.currentUser;
    if (!user) {
      throw new Error('User not authenticated');
    }

    const walletRef = doc(db, 'users', user.uid, 'wallet', 'winicoins');
    const walletDoc = await getDoc(walletRef);
    
    if (walletDoc.exists()) {
      return walletDoc.data().winicoins || 0;
    }
    
    return 0;
  } catch (error) {
    console.error('Error getting user winicoins:', error);
    return 0;
  }
};
